// src/App.js
import React, { useEffect } from 'react';
import FormularioJSON from '../../../components/FormularioJSON';
import ConsultaCategoria from '../../../../lib/json/consultas/Categorias.json'
import dadosMenu from '../../../../lib/json/menu.json';
import { useState } from 'react';
import { Col, Container, Form, Row } from 'react-bootstrap';
import empresasData from '../../../../lib/json/empresas.json'
import SelectFixo from '../../../components/SelectFixo';
import { LabelTabContainer } from './styles';
import InputGeral from '../../../components/InputGeral/Index';
import ConfiguracaoEmpresa from '../../../components/ConfigEmpresa';
import { useNavigate, useParams } from 'react-router-dom';
import { MapeamentoMenu, MapeamentoPermissao, MenuHabilitadoJSON, PermissoesEmpresasJSON, SucessoMsg } from '../../../contents/VariaveisGlobais';
import SubmitForm from '../../../components/SubmitForm';
import { ConsumoAPI_POST, ConsumoAPI_PUT } from '../../../../backend/ConsumoAPI';
import TitlePage from '../../../components/TitlePage';
import DisparaEmail from '../../../../backend/DisparaEmail';
import SelectDinamico from '../../../components/SelectDinamico';
import axios from 'axios';
import { ConsultaAPI_URL } from '../../../../backend/ConsultaAPI';

function FichaUsuarios(){
	const navigate = useNavigate();
	const { idUsuarios } = useParams();
	const [dadosUsuario, setDadosUsuario] = useState();
	const [perfilUsuario, setPerfilUsuario] = useState();
	const [optionsPerfil, setOptionsPerfil] = useState([{value: '', label: 'Digite'}])
	const empresasDisponiveis = empresasData.empresas.filter((empresa) => empresa.habilitado);
	
	const options = empresasDisponiveis.map((empresa) => ({
		value: empresa.empresaFilial + ' - ' + empresa.nomeEmpresa,
		text: empresa.nomeEmpresa,
		index: empresa.empresaFilial
	}));

	const optionsHabilitado = [{value: true, text: 'SIM'}, {value: false, text: 'NÃO'}]

	useEffect(() => {
		const fetchData = async () => {
			try {
				// Construct the public URL for the JSON file
				const jsonUrl = `usuarioSistema`;				
				const response = await ConsultaAPI_URL(jsonUrl);
				
				const data = await response;
				
				// Set the data in the component's state
				await setDadosUsuario(data);
				} catch (error) {
				console.error('Error fetching JSON:', error);
			}
		};
		
		const fetchDataPerfil = async () => {
			try {
				// Construct the public URL for the JSON file
				const jsonUrl = `/lib/perfilUsuario.json`;
				
				const response = await axios.get(jsonUrl, {
					headers: {
						'Cache-Control': 'no-cache, no-store, must-revalidate',
						'Pragma': 'no-cache',
						'Expires': '0',
					},
				});
				
				const data = await response.data;
				
				// Set the data in the component's state
				await setPerfilUsuario(data);
				} catch (error) {
				console.error('Error fetching JSON:', error);
			}
		};
	
		fetchDataPerfil();
		fetchData();
    }, []);

	useEffect(() => {
		setHabilitado(true)
		setUsuarioProtheus({value : "", label: ""})
		setHabilitadoSelect({value: true, label: 'SIM'})
		setSenhaProvisoria(true)
		
		if (dadosUsuario) {
			if (idUsuarios){
				var usuarioAlteracao 		 = dadosUsuario.usuarios.find( (item) => item.usuario === idUsuarios)
				var empresaHabilitadas	     = options && (options.filter(objeto => usuarioAlteracao.empresaHabilitadas.includes(objeto.index)).map((item) => item.value));
				var empresaHabilitadasSelect = options && (options.filter(objeto => usuarioAlteracao.empresaHabilitadas.includes(objeto.index)) );
				var centroCustoConfig = {};
				
				const solicPagto = usuarioAlteracao?.solicitacaoPagamento ?? true;
				const solPagto = { value: (solicPagto ? 'S' : 'N'), text: (solicPagto ? 'Sim' : 'Não')}
	
				JSON.parse(usuarioAlteracao.parametrosEmpresas).forEach(item => {const { empresaFilial, centroCustoSelect } = item; if (centroCustoSelect && centroCustoSelect.length > 0) {centroCustoConfig[empresaFilial] = centroCustoSelect;}})
				
				setDesabilitaUsuario(true)
				setSenhaProvisoria(usuarioAlteracao.primeiroLogin)
				setNome(usuarioAlteracao.nome)
				setUsuario(usuarioAlteracao.usuario)
				setSenhaUsuario(usuarioAlteracao.senha)
				setEmail(usuarioAlteracao.email)
				setPerfil(JSON.parse(usuarioAlteracao.perfil))
				setUsuarioProtheus(JSON.parse(usuarioAlteracao.usuarioProtheus))
				
				// if (usuarioAlteracao.aprovadorMaster){
				// 	setAprovadorMaster(JSON.parse(usuarioAlteracao.aprovadorMaster))
				// }
				
				if (usuarioAlteracao.crmAcesso){
					setRestringeCRM(JSON.parse(usuarioAlteracao.crmAcesso))
				}

				if (usuarioAlteracao.crmFunil){
					setFunilCRM(JSON.parse(usuarioAlteracao.crmFunil))
				}

				setHabilitado(usuarioAlteracao.habilitado)
				
				if (!usuarioAlteracao.habilitado){
					setHabilitadoSelect({value: false, text: 'NÃO'})
				}
				
				setEmpresas(empresaHabilitadas)
				setEmpresaHabilitadasSelect(empresaHabilitadasSelect)
				setSelecaoMenu(MenuHabilitadoJSON(JSON.parse(usuarioAlteracao.menu)));
				setSelectedValues({values: centroCustoConfig})
				setEmpresasConfig(PermissoesEmpresasJSON(JSON.parse(usuarioAlteracao.parametrosEmpresas)))
				setSolicitacaoPagamento( solPagto )
			}
		}
    }, [dadosUsuario, perfilUsuario]);

	useEffect(() => {
		if (perfilUsuario){
			const optionsAux = perfilUsuario.perfil.map((perfil) => ({
				value: perfil.idPerfil,
				text: perfil.idPerfil + ' - ' + perfil.perfil
			}));

			setOptionsPerfil(optionsAux)
		}
	}, [perfilUsuario]);

	const senhaDefault = btoa("NpeGroup@" + Date.now());
	
	const [desabilitaUsuario, setDesabilitaUsuario] = useState(false);
	const [senhaProvisoria, setSenhaProvisoria] = useState(true);
	const [selecaoMenu, setSelecaoMenu] = useState({});
	const [empresas, setEmpresas] = useState();
	const [empresaHabilitadasSelect, setEmpresaHabilitadasSelect] = useState();
	const [selectedValues, setSelectedValues] = useState({values: {}});
	const [empresasConfig, setEmpresasConfig] = useState({});
	const [perfil, setPerfil] = useState();
	const [senhaUsuario, setSenhaUsuario] = useState(senhaDefault);
	
	const [usuario, setUsuario] = useState();
	const [nome, setNome] = useState();
	const [email, setEmail] = useState();
	const [usuarioProtheus, setUsuarioProtheus] = useState();
	// const [aprovadorMaster,setAprovadorMaster] = useState();
	const [solicitacaoPagamento, setSolicitacaoPagamento] = useState({value: 'S', text: 'Sim'});
	const [restringeCRM, setRestringeCRM] = useState();
	const [funilCRM, setFunilCRM] = useState();

	const [habilitado, setHabilitado] = useState();
	const [habilitadoSelect, setHabilitadoSelect] = useState();

	const handleCancel = () => {
		navigate('/configuracoes/Usuarios');
	}
	
	const handleSave = () => {
		const Menu = MapeamentoMenu(selecaoMenu, dadosMenu)
		const perfilEmpresa = MapeamentoPermissao(empresasConfig, selectedValues, empresas)

		const novoArquivoJson = JSON.stringify(Menu, null, 2);
		const perfilEmpresaJSON = JSON.stringify(perfilEmpresa, null, 2);
		const perfilJSON = JSON.stringify(perfil || "", null, 2);
		const usuarioProtheusJSON = JSON.stringify(usuarioProtheus || "", null, 2);
		// const aprovadorMasterJSON = JSON.stringify(aprovadorMaster || "", null, 2);
		//aprovadorMaster: aprovadorMasterJSON,
		const restringeCRMJSON = JSON.stringify(restringeCRM || "", null, 2);
		const funilCRMJSON = JSON.stringify(funilCRM || "", null, 2);

		const jsonUsuario = {
			nome: nome,
			usuario: usuario,
			senha: senhaUsuario,
			email: email,
			perfil: perfilJSON,
			usuarioProtheus: usuarioProtheusJSON,
			primeiroLogin: senhaProvisoria,
			habilitado: habilitado,
			empresaHabilitadas: empresas ? empresas.map( (item) => { return item.split('-')[0].trim() } ) : '',
			menu: novoArquivoJson,
			parametrosEmpresas: perfilEmpresaJSON,
			solicitacaoPagamento: solicitacaoPagamento.value == 'S',
			crmFunil: funilCRMJSON,
			crmAcesso: restringeCRMJSON
		}

		salvarArquivoUsuario(jsonUsuario);
	};

	const usuariosLoadJSON = async () => {
		try {
			// Construct the public URL for the JSON file
			const jsonUrl = `usuarioSistema`;				
			const response = await ConsultaAPI_URL(jsonUrl);
			
			const data = await response;
			
			// Set the data in the component's state
			return data
			} catch (error) {
			console.error('Error fetching JSON:', error);
		}
	};

	const salvarArquivoUsuario = async (usuarioSave) => {
		var liberaAcesso = false
		// var UsuariosJSON = null
		const usuariosDados = await usuariosLoadJSON()

		if (idUsuarios){
			usuariosDados.usuarios.map( (item) => { 
				if (item.usuario === idUsuarios){
					liberaAcesso = item.habilitado !== usuarioSave.habilitado && usuarioSave.habilitado === true
				}
			})
		}
			
		try {
			const response = await ( idUsuarios ?
							ConsumoAPI_PUT('usuarioSistema', usuarioSave) :
							ConsumoAPI_POST('usuarioSistema', usuarioSave) );
			
			if (response.error === "00"){
				if (!idUsuarios){
					DisparaEmail({
						destinatario: usuarioSave.email,
						assunto: 'Criação de Usuario - Tools System',
						corpo: `<p>Prezado ${usuarioSave.nome},</p>
						<p>É com grande satisfação que informamos que seu cadastro foi concluído com sucesso em nosso sistema. Seja muito bem-vindo(a)!</p>
						<p>A seguir, fornecemos algumas informações importantes:</p>
						<br/>
						<p><strong>Detalhes da Conta:</strong></p>
						<p><strong>Nome de Usuário:</strong> ${usuarioSave.usuario}</p>
						<p><strong>E-mail Cadastrado:</strong> ${usuarioSave.email}</p>
						<p><strong>Senha Provisória:</strong> ${atob(usuarioSave.senha)}</p>`
					});
				}
				
				if (liberaAcesso){
					DisparaEmail({
						destinatario: usuarioSave.email,
						assunto: 'Liberação de Usuario - Tools System',
						corpo: `<p>Prezado ${usuarioSave.nome},</p>
						<p>É com prazer que informamos que sua solicitação de acesso ao sistema Tools System foi aprovada. Seu acesso agora está oficialmente liberado e você pode começar a utilizar todas as funcionalidades disponíveis no sistema.</p>
						<p>Caso encontre alguma dificuldade durante o processo de login ou precisar de assistência adicional, não hesite em entrar em contato conosco. Estamos aqui para ajudar.</p>
						<p>Agradecemos pela sua paciência e cooperação durante o processo de solicitação de acesso. Estamos ansiosos para vê-lo utilizando o sistema Tools System e aproveitando todas as suas vantagens.</p>
						<p>Cordialmente,<br>Departamento de Tecnologia</p>`
					});
				}
				
				// handleCancel();
				SucessoMsg(response.description);
			}
		} catch (error) {
			console.error('Error saving JSON file', error);
		}
	};

	const handleCheckboxChange = (item, isChecked, itemSelect) => {
		setSelecaoMenu((prevSelecoes) => ({
			...prevSelecoes,
			[itemSelect]: isChecked,
		}));
	};

	const handleChangeEmpresas = (selectedOption) =>{
		setEmpresas(selectedOption.map((item) => {return item.value} ));
		setEmpresaHabilitadasSelect(selectedOption)
	}

	const handleChangePerfil = (selectedOption) =>{
		setPerfil(selectedOption);
		
		if (selectedOption.value){
			const idPerfilUsuario 			= selectedOption.value
			var perfilSelecionado 			= perfilUsuario.perfil.find( (item) => item.idPerfil === idPerfilUsuario)
			var empresaHabilitadas	    	= options && (options.filter(objeto => perfilSelecionado.empresaHabilitadas.includes(objeto.index)).map((item) => item.value));
			var empresaHabilitadasSelect 	= options && (options.filter(objeto => perfilSelecionado.empresaHabilitadas.includes(objeto.index)) );
			var centroCustoConfig 			= {};

			JSON.parse(perfilSelecionado.parametrosEmpresas).forEach(item => {const { empresaFilial, centroCustoSelect } = item; if (centroCustoSelect && centroCustoSelect.length > 0) {centroCustoConfig[empresaFilial] = centroCustoSelect;}})
			
			setEmpresasConfig(PermissoesEmpresasJSON(JSON.parse(perfilSelecionado.parametrosEmpresas)))
			setSelecaoMenu(MenuHabilitadoJSON(JSON.parse(perfilSelecionado.menu)));
			setEmpresas(empresaHabilitadas)
			setEmpresaHabilitadasSelect(empresaHabilitadasSelect)
			setSelectedValues({values: centroCustoConfig})
		}
	}

	const handleChangeHabilitado = (selectedOption) =>{
		setHabilitado(selectedOption.value);
		setHabilitadoSelect(selectedOption);
	}

	const handleParametrosEmpresas = (item, isChecked, itemSelect) => {
		setEmpresasConfig((prevSelecoes) => ({
			...prevSelecoes,
			[itemSelect]: isChecked,
		}));
	};

	const handleSelectionChange = (values) => {
		setSelectedValues((centroCusto) => ({
			...centroCusto,
			values,
		}));
	};

	return (
		<>
			<Row>
				<Col md="12" xs="12">
					<TitlePage 
						text="Usuários"
					/>
				</Col>
				<Col md="4" xs="12">
					<InputGeral 
						label="Usuario" 
						tipo='text' 
						value={usuario} 
						onChange={(e) => setUsuario(e.target.value)} 
						disabled={desabilitaUsuario}
					/>
				</Col>
				<Col md="6" xs="12">
					<InputGeral 
						label="Nome Completo" 
						tipo='text' 
						value={nome} 
						onChange={(e) => setNome(e.target.value)}
					/>
				</Col>
				<Col md="2" xs="12">
					<SelectFixo 
						multiple={false} 
						options={optionsHabilitado} 
						value={habilitado} 
						selectedOptionValue={habilitadoSelect} 
						isLabel={true} 
						label="Habilitado" 
						onChange={handleChangeHabilitado}
					/>
				</Col>
				<Col md="3" xs="12">
					<SelectFixo 
						multiple={false} 
						options={optionsPerfil} 
						value={perfil} 
						selectedOptionValue={perfil} 
						isLabel={true} 
						label="Perfil Usuário" 
						onChange={handleChangePerfil}
					/>
				</Col>
				<Col md="6" xs="12">
					<InputGeral 
						label="E-mail" 
						tipo='email' 
						value={email} 
						onChange={(e) => setEmail(e.target.value)}
						disabled={desabilitaUsuario}
					/>
				</Col>
				<Col md="3" xs="12">
					<SelectDinamico 
                        label="Usuario Protheus"
                        campoValue={usuarioProtheus}
                        value={usuarioProtheus}
                        cValue="Usuario"
                        cText="Nome"
                        consulta="Usuario"
                        tabela="USER"
                        isMultiplo={false}
                        onchange={(e) => setUsuarioProtheus(e)}
                    />
				</Col>
				{/* <Col md="6" xs="12">
					<SelectDinamico 
                        label="Aprovador Master"
                        campoValue={aprovadorMaster}
                        value={aprovadorMaster}
                        cValue="Usuario"
                        cText="Nome"
                        consulta="Usuario"
                        tabela="USER"
                        isMultiplo={false}
                        onchange={(e) => setAprovadorMaster(e)}
                    />
				</Col> */}
				<Col md="12" xs="12">
					<SelectFixo 
						multiple={true} 
						options={options} 
						value={empresas} 
						selectedOptionValue={empresaHabilitadasSelect} 
						isLabel={true} 
						label="Empresas" 
						onChange={handleChangeEmpresas}
					/>
				</Col>
				<Col md="12" xs="12">
					<Form.Group controlId="example,3Form.ControlInput1">
						<LabelTabContainer id="inputGroup-sizing-sm" className="input-group-text">Menu de Usuário</LabelTabContainer>
						<Form.Label id="inputGroup-sizing-sm" className="input-group-text">
							<FormularioJSON 
								dados={dadosMenu} 
								onChecked={handleCheckboxChange} 
								selecoes={selecaoMenu}
							/>
						</Form.Label>
					</Form.Group>
				</Col>
			</Row>
			<Form.Group >
				<LabelTabContainer id="inputGroup-sizing-sm" className="input-group-text">Solicitação de Pagamento</LabelTabContainer>
				<Form.Label id="inputGroup-sizing-sm" className="input-group-text">
					<Row className='w-100'>
						<Col md="3" xs="12">
							<SelectFixo 
								multiple={false} 
								options={[
									{
										value: 'S',
										text: 'SIM'
									},
									{
										value: 'N',
										text: 'NÃO'
									}
								]} 
								value={solicitacaoPagamento}
								selectedOptionValue={solicitacaoPagamento}
								isLabel={true} 
								label="Restringir Visualização" 
								onChange={(e) => setSolicitacaoPagamento(e)}
							/>
						</Col>
					</Row>
				</Form.Label>
			</Form.Group>
			<Form.Group >
				<LabelTabContainer id="inputGroup-sizing-sm" className="input-group-text">CRM</LabelTabContainer>
				<Form.Label id="inputGroup-sizing-sm" className="input-group-text">
					<Row className='w-100'>
						<Col md="9" xs="12">
							<SelectDinamico 
								label="Funil Habilitado"
								campoValue={funilCRM}
								value={funilCRM}
								cValue="Id"
								cText="Descricao"
								consulta={ConsultaCategoria.consulta}
								tabela={ConsultaCategoria.tabelas}
								isMultiplo={true}
								showNoFilter={false}
								onchange={(e) => setFunilCRM(e)}
							/>
						</Col>
						<Col md="3" xs="12">
							<SelectFixo 
								multiple={false} 
								options={[
									{
										value: 'S',
										text: 'SIM'
									},
									{
										value: 'N',
										text: 'NÃO'
									}
								]} 
								value={restringeCRM} 
								isLabel={true} 
								label="Restringir Visualização" 
								onChange={(e) => setRestringeCRM(e)}
							/>
						</Col>
					</Row>
				</Form.Label>
			</Form.Group>
			
			{ empresas && 
				(
					<Row>
						<Col md="12" xs="12">
							<Form.Group >
								<LabelTabContainer id="inputGroup-sizing-sm" className="input-group-text">Parâmetros por Empresa</LabelTabContainer>
								<Form.Label id="inputGroup-sizing-sm" className="input-group-text">
									<ConfiguracaoEmpresa 
										empresas={empresas} 
										selecionados={empresasConfig} 
										centroCustoSelecionados={selectedValues.values} 
										preencheValue={handleParametrosEmpresas} 
										onSelectionChange={handleSelectionChange
									}/>
								</Form.Label>
							</Form.Group>
						</Col>
					</Row>
					
				)
			}
				
			<SubmitForm onSave={handleSave} onCancel={"Cancelar"}></SubmitForm>
		</>
	);
};

export default FichaUsuarios;